import { getHeaders } from "./headers.service";
import { RefreshTokenResponse } from "../presentation/interfaces/refresh-token-response.interface";
import { CryptoHelper } from "../encription/encription";

const BASE_URL = `${process.env.REACT_APP_VEEP_API}`;

async function makeRequest(url: string, options: RequestInit): Promise<Response> {
    return fetch(`${BASE_URL}/api/${url}`, {
        ...options,
        credentials: "include"
    });
}

async function setRequestOptions(accessToken: string, options: RequestInit = {}) {
    let requestOptions: RequestInit = {
        ...options,
        headers: {
            ...getHeaders(accessToken),
            ...options.headers,
        },
        body: options.body ? options.body : undefined,
    };
    return requestOptions;
}

export async function interceptorFetch(
    url: string,
    accessToken: string,
    updateToken: (newToken: string) => void,
    options: RequestInit = {}
): Promise<Response> {
    try {
        let requestedOptions = await setRequestOptions(accessToken, options);
        let response = await makeRequest(url, requestedOptions);

        if (response.status === 401) {
            const { ok, token } = await refreshAccessToken(updateToken);
            if (ok && token) {
                requestedOptions = await setRequestOptions(token, options);
                response = await makeRequest(url, requestedOptions);
            }
        }

        return response;
    } catch (error) {
        throw error;
    }
}

/**
 * Request a new access token using the refresh token.
 */
export async function refreshAccessToken(updateToken: (newToken: string) => void): Promise<RefreshTokenResponse> {
    try {
        const response = await fetch(`${BASE_URL}/api/auth/refresh`, {
            method: "POST",
            credentials: "include",
        });
        if (response.status === 403) { // Refresh token has expired
            const errorData = await response.json();
            return Promise.reject(errorData);
        }

        if (!response.ok) return { status: response.status, ok: false, token: null };

        const { token } = await response.json();
        if (!token) return { status: response.status, ok: false, token: null };

        //Refresh token in authentication context
        const newAccessToken = CryptoHelper.decryptData(token);
        updateToken(newAccessToken);
        return { status: response.status, ok: true, token: newAccessToken };
    } catch (error) {
        return { status: 500, ok: false, token: null };
    }
}